import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { PersistenceService } from '../services/persistence.service';
import { AuthenticationService, AuthenticatedUser } from '../services/authentication.service';
import { ControllerService } from '../services/controller/controller.service';
import { firstValueFrom, filter, first } from 'rxjs';
import { GetWorklistResponse } from '../models/responses/get-worklist-response';

export const worklistResolver: ResolveFn<GetWorklistResponse | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const persistenceService = inject(PersistenceService);
  const authenticationService = inject(AuthenticationService);
  const controllerService = inject(ControllerService);

  return firstValueFrom(
    authenticationService.currentUser$.pipe(
      filter((user): user is AuthenticatedUser => !!user),
      first()
    )
  ).then(async (currentUser) => {
    const courseId = route.params['courseId'];
    const assignmentId = route.params['assignmentId'];

    // Show loading indicator
    const loading = await controllerService.loading();
    await loading.present();

    try {
      const response = await persistenceService.getWorklist({
        userId: currentUser.userId,
        courseId: courseId,
        assignmentId: assignmentId
      });
      await loading.dismiss();
      return response;
    } catch (error) {
      console.error('Failed to load worklist:', error);
      await loading.dismiss();
      return null;
    }
  });
};

